module.exports = __webpack_public_path__ + "static/media/montserrat-all-400-normal.aa917f2f.woff";